// src/pages/analyse&document.js
import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { businessSchemaDE, businessSchemaEN } from "../schema";
import AAndD from "../components/analyse&document/analyse&document";

// Import page-level translations
import analyseEnTranslations from "../translations/analyse_en.json";
import analyseDeTranslations from "../translations/analyse_de.json";

const AnalyseAndDocumentPage = () => {
  const { t, i18n } = useTranslation();

  // Add translations for this page
  i18n.addResourceBundle(
    "en",
    "analysePage",
    analyseEnTranslations,
    true,
    true
  );
  i18n.addResourceBundle(
    "de",
    "analysePage",
    analyseDeTranslations,
    true,
    true
  );

  const currentSchema =
    i18n.language === "en" ? businessSchemaEN : businessSchemaDE;

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(currentSchema)}
        </script>
        <title>{t("analysePage:page_title")}</title>
        <meta name="description" content={t("analysePage:meta_description")} />
        <meta name="keywords" content={t("analysePage:meta_keywords")} />
        <meta property="og:title" content={t("analysePage:page_title")} />
        <meta
          property="og:description"
          content={t("analysePage:meta_description")}
        />
      </Helmet>
      <div>
        <AAndD />
      </div>
    </>
  );
};

export default AnalyseAndDocumentPage;
